import { acquireToken } from "src/lib/acquireToken";
import { apiWrapper } from "src/services/request";
import { AIGCPIPLINEAPI } from "src/services/apis";
import { TopicInput } from "src/types/workflows";
import { FeedbackDto } from "src/types/feedback";
import axios from "axios";

export const queryWorkflowList = async (props: {
    days: number;
    start: number;
    size: number;
    workflowId: string;
    sessionId: string;
    workflowTemplateName: string;
}) => {
    const {
        days,
        start,
        size,
        workflowId,
        sessionId,
        workflowTemplateName,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.onlineWorkflowList,
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
        params: {
            days,
            start,
            size,
            workflowId,
            sessionId,
            workflowTemplateName,
        },
    };
    return apiWrapper({
        config,
    });
};

export const queryWorkflowStatus = async (props: {
    workflowId: string;
}) => {
    const {
        workflowId,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.onlineWorkflowStatus.replace("{workflowId}", workflowId),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

export const deleteWorkflow = async (props: {
    workflowId: string;
}) => {
    const {
        workflowId,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.onlineWorkflowInstance.replace("{workflowId}", workflowId),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "DELETE",
    };
    return apiWrapper({
        config,
    });
};

export const kickoffWorkflow = async (props: {
    workflowId: string;
}) => {
    const {
        workflowId,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.kickoffOnlineWorkflow.replace("{workflowId}", workflowId),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "POST",
    };
    return apiWrapper({
        config,
    });
};

export const rerunTask = async (props: {
    workflowId: string;
    taskName: string;
}) => {
    const {
        workflowId,
        taskName,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.rerunOnlineWorkflow.replace("{workflowId}", workflowId).replace("{taskName}", taskName),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "POST",
    };
    return apiWrapper({
        config,
    });
};

export const rerunTaskNoOverwrite = async (props: {
    workflowId: string;
    taskName: string;
}) => {
    const {
        workflowId,
        taskName,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.rerunOnlineWorkflowNoOverwrite
            .replace("{workflowId}", workflowId)
            .replace("{taskName}", taskName),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "POST",
    };
    return apiWrapper({
        config,
    });
};

export const getSmartArtVariants = async (props: {
    workflowId: string;
}) => {
    const { workflowId } = props;
    const config = {
        url: AIGCPIPLINEAPI.smartArtVariants.replace("{workflowId}", workflowId),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

export const uploadFile = async (props: {
    workflowId: string;
    taskName: string;
    formData: FormData
}) => {
    const {
        workflowId,
        taskName,
        formData,
    } = props;
    // const config = {
    //     url: AIGCPIPLINEAPI.onlineWorkflowUploadFile
    //         .replace("{workflowId}", workflowId)
    //         .replace("{taskName}", taskName),
    //     baseURL: process.env.REACT_APP_AIGC_BASE_URL,
    //     headers: {
    //         Authorization: `Bearer ${await aquireToken()}`,
    //         "Content-Type": "multipart/form-data",
    //     },
    //     method: "POST",
    //     formData,
    // };
    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 20000,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return axiosInstance.post(AIGCPIPLINEAPI.onlineWorkflowUploadFile
        .replace("{workflowId}", workflowId)
        .replace("{taskName}", taskName), formData);
};

export const postProcessFile = async (props: {
    formData: FormData
}) => {
    const {
        formData,
    } = props;
    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 600000,
        responseType: "blob",
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return axiosInstance.post(AIGCPIPLINEAPI.PostProcess, formData);
};

export const reverseSlidemasterFile = async (props: {
    formData: FormData
}) => {
    const {
        formData,
    } = props;
    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 600000,
        responseType: "blob",
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return axiosInstance.post(AIGCPIPLINEAPI.ReverseSlideMaster, formData);
};

export const generateAltTextImages = async (props: {
    formData: FormData
}) => {
    const {
        formData,
    } = props;
    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 600000,
        responseType: "json",
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return axiosInstance.post(AIGCPIPLINEAPI.GenerateAltTextImages, formData);
};

export const compressTemplate = async (props: {
    formData: FormData,
    quality: number,
}) => {
    const {
        formData,
        quality,
    } = props;
    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 600000,
        responseType: "blob",
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return axiosInstance.post(AIGCPIPLINEAPI.CompressImage.replace("{quality}", quality.toString()), formData);
};

export const changeImage = async (props: {
    formData: FormData
}) => {
    const {
        formData,
    } = props;
    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 600000,
        responseType: "blob",
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return axiosInstance.post(AIGCPIPLINEAPI.changeImage, formData);
};

export const generateOneSlide = async (props: {
    formData: FormData
}) => {
    const {
        formData,
    } = props;
    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 600000,
        responseType: "blob",
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return axiosInstance.post(AIGCPIPLINEAPI.generateOneSlide, formData);
};

export const changeThemeColor = async (props: {
    formData: FormData
}) => {
    const {
        formData,
    } = props;
    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 600000,
        responseType: "blob",
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return axiosInstance.post(AIGCPIPLINEAPI.ChangeThemeColor, formData);
};

export const generateAndAnalyzeImage = async (props: {
    data: string
}) => {
    const {
        data,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.GenerateAndAnalyzeImage,
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "application/json",
        },
        method: "POST",
        data,
    };
    return apiWrapper({
        config,
    });
};

export const queryWorkflowTemplates = async () => {
    const config = {
        url: AIGCPIPLINEAPI.onlineWorkflowTemplates,
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

export const querySubstyles = async (props: {
    templateStyle: string;
}) => {
    const {
        templateStyle,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.Substyles.replace("{style}", templateStyle),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

export const queryStyles = async (props: {
    workflowTemplateName: string;
}) => {
    const {
        workflowTemplateName,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.Styles.replace("{workflowTemplateName}", workflowTemplateName),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

export const queryLanguages = async () => {
    const config = {
        url: AIGCPIPLINEAPI.Languages,
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

export const queryRegions = async () => {
    const config = {
        url: AIGCPIPLINEAPI.Regions,
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

export const queryMjGenerationModes = async () => {
    const config = {
        url: AIGCPIPLINEAPI.MjGenerationModes,
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

export const queryImageGenerationModels = async () => {
    const config = {
        url: AIGCPIPLINEAPI.ImageGenerationModels,
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

export const submitFeedback = async (props: FeedbackDto) => {
    const config = {
        url: AIGCPIPLINEAPI.feedback,
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "application/json",
        },
        method: "POST",
        data: props,
    };
    return apiWrapper({
        config,
    });
};

export const createWorkflow = async (props: {
    workflowTemplateName: string
    data: TopicInput
}) => {
    const {
        workflowTemplateName,
        data,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.onlineWorkflow.replace("{workflowTemplateName}", workflowTemplateName),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "POST",
        data,
    };
    return apiWrapper({
        config,
    });
};

export const queryIcons = async (props: {
    query: string;
    styles?: string[];
    pageIndex?: number;
    pageSize?: number;
    options?: {
        textSearch: boolean;
        vectorSearch: boolean;
        semanticRanking: boolean;
    };
    rankWithLLM?: boolean;
}) => {
    const {
        query,
        styles,
        pageIndex = 1,
        pageSize = 10,
        options,
        rankWithLLM = false,
    } = props;
    const config = {
        url: AIGCPIPLINEAPI.iconQuery_POST,
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "application/json",
        },
        method: "POST",
        data: {
            query,
            styles,
            pageIndex,
            pageSize,
            // Add user-selected search options (lower-case per requirement)
            options: options ? {
                textSearch: !!options.textSearch,
                vectorSearch: !!options.vectorSearch,
                semanticRanking: !!options.semanticRanking,
            } : undefined,
            rankWithLLM,
        },
    };
    return apiWrapper({
        config,
    });
};

export const getIconUrl = async (props: {
    iconId: string;
    iconStyle?: string;
}) => {
    const {
        iconId,
        iconStyle,
    } = props;
    // First, call the backend to get the icon download URL(s)
    const config = {
        url: AIGCPIPLINEAPI.iconGetUrl_GET.replace("{iconId}", iconId),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
        params: {
            preferredStyles: iconStyle || undefined,
        },
    };
    const data = await apiWrapper({ config });

    return data;
};

export const querySessionMessages = async (props: {
    sessionId: string;
}) => {
    const { sessionId } = props;
    const config = {
        url: AIGCPIPLINEAPI.sessionMessages.replace("{sessionId}", sessionId),
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
        },
        method: "GET",
    };
    return apiWrapper({
        config,
    });
};

// API for decoration icon generation (returns base64 PNG)
export const createDecoration = async (props: {
    content: string;
    mainColor: string;
}): Promise<string> => {
    const { content, mainColor } = props;

    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 120000,
        responseType: "json",
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "application/json",
        },
    });

    const response = await axiosInstance.post(
        AIGCPIPLINEAPI.decoration,
        { content, main_color: mainColor },
    );

    // Extract PNG base64 from the JSON response
    if (response.data && response.data.success && response.data.png_base64) {
        return response.data.png_base64;
    }

    if (response.data && response.data.error) {
        throw new Error(response.data.error);
    }

    throw new Error("Failed to generate decoration image");
};

// Response type for decoration with style transfer (returns binary PNG blob)
export interface StyleFromImageResult {
    blob: Blob;
    extractedSubject: string | null;
    mainColor: string | null;
    styleSummary: string | null;
}

// API for decoration icon generation with style transfer from reference image
// Returns binary PNG blob (not base64 JSON)
export const createDecorationStyleFromImage = async (props: {
    content: string;
    mainColor: string;
    backgroundImage: string; // Base64 encoded reference image
}): Promise<StyleFromImageResult> => {
    const { content, mainColor, backgroundImage } = props;

    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 180000, // Longer timeout for style analysis + generation
        responseType: "blob", // Binary PNG response
        headers: {
            Authorization: `Bearer ${await acquireToken()}`,
            "Content-Type": "application/json",
        },
    });

    const response = await axiosInstance.post(
        AIGCPIPLINEAPI.decorationStyleFromImage,
        {
            content,
            main_color: mainColor,
            background_image: backgroundImage,
        },
    );

    // Extract metadata from headers
    const extractedSubject = response.headers["x-extracted-subject"] || null;
    const responseMainColor = response.headers["x-main-color"] || null;
    const styleSummary = response.headers["x-style-summary"] || null;

    // Return blob and metadata
    return {
        blob: response.data as Blob,
        extractedSubject,
        mainColor: responseMainColor,
        styleSummary,
    };
};

// Response type for batch decoration (returns ZIP with manifest)
export interface BatchDecorationImage {
    index: number;
    subject: string;
    blob: Blob | null;
    objectUrl: string | null;
    status: "success" | "failed";
}

export interface BatchDecorationResult {
    zipBlob: Blob;
    images: BatchDecorationImage[];
    manifest: {
        total: number;
        successful: number;
        failed: number;
    };
}

// Helper function to read uint16 from Uint8Array (little-endian)
function readUint16LE(data: Uint8Array, offset: number): number {
    // eslint-disable-next-line no-bitwise
    return data[offset] + (data[offset + 1] << 8);
}

// Helper function to read uint32 from Uint8Array (little-endian)
function readUint32LE(data: Uint8Array, offset: number): number {
    /* eslint-disable no-bitwise */
    return (
        data[offset]
        + (data[offset + 1] << 8)
        + (data[offset + 2] << 16)
        + ((data[offset + 3] << 24) >>> 0)
    );
    /* eslint-enable no-bitwise */
}

// Utility function to unzip the batch decoration response
// Uses a simple ZIP parser without external dependency
async function unzipBatchResponse(zipBlob: Blob): Promise<BatchDecorationResult> {
    const zipArrayBuffer = await zipBlob.arrayBuffer();
    const zipData = new Uint8Array(zipArrayBuffer);

    // Simple ZIP parser for our specific use case
    const images: BatchDecorationImage[] = [];
    let manifest = { total: 0, successful: 0, failed: 0 };

    // Find end of central directory signature (0x06054b50)
    let eocdOffset = -1;
    // eslint-disable-next-line no-plusplus
    for (let i = zipData.length - 22; i >= 0; i--) {
        const isPKSignature = zipData[i] === 0x50
            && zipData[i + 1] === 0x4b
            && zipData[i + 2] === 0x05
            && zipData[i + 3] === 0x06;
        if (isPKSignature) {
            eocdOffset = i;
            break;
        }
    }

    if (eocdOffset === -1) {
        throw new Error("Invalid ZIP file: EOCD not found");
    }

    // Read central directory offset
    const cdOffset = readUint32LE(zipData, eocdOffset + 16);

    // Parse central directory entries
    let pos = cdOffset;
    while (pos < eocdOffset) {
        // Check for central directory file header signature (0x02014b50)
        const isCDHeader = zipData[pos] === 0x50
            && zipData[pos + 1] === 0x4b
            && zipData[pos + 2] === 0x01
            && zipData[pos + 3] === 0x02;
        if (!isCDHeader) {
            break;
        }

        const compressionMethod = readUint16LE(zipData, pos + 10);
        const uncompressedSize = readUint32LE(zipData, pos + 24);
        const fileNameLength = readUint16LE(zipData, pos + 28);
        const extraLength = readUint16LE(zipData, pos + 30);
        const commentLength = readUint16LE(zipData, pos + 32);
        const localHeaderOffset = readUint32LE(zipData, pos + 42);

        // Read filename
        const fileNameBytes = zipData.slice(pos + 46, pos + 46 + fileNameLength);
        const fileName = new TextDecoder().decode(fileNameBytes);

        // Move to local file header to get actual data
        const localPos = localHeaderOffset;
        const localFileNameLength = readUint16LE(zipData, localPos + 26);
        const localExtraLength = readUint16LE(zipData, localPos + 28);
        const dataStart = localPos + 30 + localFileNameLength + localExtraLength;

        // Extract file data (only handle uncompressed files - compression method 0)
        if (compressionMethod === 0) {
            const fileData = zipData.slice(dataStart, dataStart + uncompressedSize);

            if (fileName === "manifest.json") {
                // Parse manifest
                const manifestText = new TextDecoder().decode(fileData);
                const manifestData = JSON.parse(manifestText);
                manifest = {
                    total: manifestData.total ?? 0,
                    successful: manifestData.successful ?? 0,
                    failed: manifestData.failed ?? 0,
                };

                // Extract image metadata from manifest
                if (manifestData.images && Array.isArray(manifestData.images)) {
                    manifestData.images.forEach((img: {
                        index: number;
                        subject?: string;
                        status?: string;
                    }) => {
                        images.push({
                            index: img.index,
                            subject: img.subject ?? `Image ${img.index}`,
                            blob: null,
                            objectUrl: null,
                            status: img.status === "success" ? "success" : "failed",
                        });
                    });
                }
            } else if (fileName.endsWith(".png")) {
                // This is an image file
                const indexMatch = fileName.match(/^(\d+)\.png$/);
                if (indexMatch) {
                    const imageIndex = parseInt(indexMatch[1], 10);
                    const imageBlob = new Blob([fileData], { type: "image/png" });
                    const objectUrl = URL.createObjectURL(imageBlob);

                    // Find existing entry or create new one
                    const existingEntry = images.find(
                        (img) => img.index === imageIndex,
                    );
                    if (existingEntry) {
                        existingEntry.blob = imageBlob;
                        existingEntry.objectUrl = objectUrl;
                    } else {
                        images.push({
                            index: imageIndex,
                            subject: `Image ${imageIndex}`,
                            blob: imageBlob,
                            objectUrl,
                            status: "success",
                        });
                    }
                }
            }
        }

        // Move to next entry
        pos += 46 + fileNameLength + extraLength + commentLength;
    }

    // Sort images by index
    images.sort((a, b) => a.index - b.index);

    return {
        zipBlob,
        images,
        manifest,
    };
}

// API for batch decoration icon generation (returns ZIP file)
// Note: This endpoint does not require authentication
export const createDecorationBatch = async (props: {
    contents: string[];
    mainColor: string;
}): Promise<BatchDecorationResult> => {
    const { contents, mainColor } = props;

    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_AIGC_BASE_URL,
        timeout: 600000, // 10 minutes for batch processing
        responseType: "blob", // ZIP file response
        headers: {
            "Content-Type": "application/json",
        },
    });

    const response = await axiosInstance.post(
        AIGCPIPLINEAPI.decorationBatch,
        { contents, main_color: mainColor },
    );

    // Unzip and parse the response
    return unzipBatchResponse(response.data as Blob);
};
